import omitBy from "lodash/omitBy";
import isEmpty from "lodash/isEmpty";

const useGenerateNavPath = () => {
  const generateNavPath = (path: string, queryParams?: any) => {
    const queryObj = queryParams || {};
    let params = queryParams
      ? new URLSearchParams(omitBy(queryObj, isEmpty)).toString()
      : "";
    return `${path}?${params}`;
  };
  return {
    generateNavPath,
  };
};

export default useGenerateNavPath;
